import { atom } from "jotai";
import { ExistingMerchantData } from "../data/dataContracts";

export const contractExistingDataState = atom<
  ExistingMerchantData | undefined
>();
